/*
 * @Author: changcheng 364000100@#qq.com
 * @Date: 2026-07-07 14:18:37
 * @LastEditors: changcheng 364000100@#qq.com
 * @LastEditTime: 2026-07-07 16:14:47
 * @FilePath: /cancerMeeting/Users/changcheng/Downloads/mvw_project/mvw-online-pc/src/pages/saleActivity/components/ActivityCard.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Button, message, Tag } from "antd";
import { TeamOutlined, UserOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import projectDefault from "../../../img/project_default.jpg";
import { SaleActivityInfo } from "../types";
import { canSaleActivityExpertSignUp, canSaleActivityUserSignUp, isSaleActivityEnded } from "../status";

interface Props {
  activity: SaleActivityInfo;
  compact?: boolean;
  onRefresh?: () => void;
}

export default function ActivityCard({ activity, compact }: Props) {
  const history = useHistory();
  const id = activity.activityId;
  const img = activity.pictureUrl || projectDefault;
  const jumpDetail = () => {
    if (isSaleActivityEnded(activity)) {
      message.warning("活动已结束，无法查看活动详情");
      return;
    }
    history.push(`/saleActivityDetail?activityId=${id}`);
  };
  const jumpExpert = (e: any) => {
    e.stopPropagation();
    history.push(`/saleActivityExpertSignUp?activityId=${id}`);
  };
  const jumpUser = (e: any) => {
    e.stopPropagation();
    history.push(`/saleActivityUserSignUp?activityId=${id}`);
  };

  return (
    <div
      className={`sale-activity-card${compact ? " sale-activity-card--compact" : ""}`}
      onClick={jumpDetail}
    >
      <div className="sale-activity-card__cover-wrap">
        <img className="sale-activity-card__cover" src={img} alt={activity.name} />
        {compact && (
          <span className="sale-activity-card__status">
            {activity.activityLearnStatusText || "学术活动"}
          </span>
        )}
      </div>
      <div className="sale-activity-card__body">
        <div className="sale-activity-card__title">{activity.name}</div>
        {compact ? null : (
          <>
            <div className="sale-activity-card__meta">
              <span>{activity.hostUnit || "主办单位待定"}</span>
              <Tag color={activity.activityLearnStatus === 2 ? "green" : "blue"}>
                {activity.activityLearnStatusText || "学术活动"}
              </Tag>
            </div>
            <div className="sale-activity-card__time">
              {activity.beginTimeText || activity.beginTime || "--"} 至{" "}
              {activity.endTimeText || activity.endTime || "--"}
            </div>
          </>
        )}
        <div className="sale-activity-card__footer">
          <div className="sale-activity-card__actions">
            <Button
              className="sale-activity-card__button sale-activity-card__button--expert"
              size="small"
              icon={<UserOutlined />}
              disabled={!canSaleActivityExpertSignUp(activity)}
              onClick={jumpExpert}
            >
              专家报名
            </Button>
            <Button
              className="sale-activity-card__button sale-activity-card__button--user"
              size="small"
              type="primary"
              icon={<TeamOutlined />}
              disabled={!canSaleActivityUserSignUp(activity)}
              onClick={jumpUser}
            >
              学员报名
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
